import { WSandTableButton } from '../WSandTableButton';
import { TProjectButtons } from './TProjectButtons';
import { TProjectPanel } from './TProjectPanel';

export function TProject() {
  return (
    <>
      <div className="absolute top-0 left-15">
        <WSandTableButton />
      </div>
      <TProjectButtons />
      <TProjectPanel />
    </>
  );
}
